exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.title-dudas[data-v-727bd5a9]{\n    font-size: 1.15rem;\n}\n\n", ""]);
